import { Dashboard } from './DashboardRoutes'
import { Editor } from './EditorRoutes'
import { SingleProject } from './ProjectRoutes'

/**
 * Where a sign-in actually lands, and the chunk each of those needs.
 *
 * Only the destinations brand hands off to, in rough order of how often: the
 * dashboard takes all but a handful, and the rest are deep links out of the
 * marketing site. Anything not listed simply isn't warmed and behaves as it
 * always did — the point is to overlap the common cases, not to enumerate the
 * router a second time.
 */
const DESTINATIONS = [
  { matches: (path) => path === '/' || path === '/dashboard', component: Dashboard },
  { matches: (path) => path.startsWith('/editor/'), component: Editor },
  { matches: (path) => path.startsWith('/project/'), component: SingleProject }
]

/**
 * Starts the chunk for `pathname` downloading now, rather than when the router
 * gets there.
 *
 * Called as early as the destination is known — on boot, and again from
 * `/auth/callback` once the `r` parameter has been read. Everything behind
 * `RequireAuth` otherwise waits for the whole sign-in to resolve before its
 * chunk is even requested, which turns two waits that could overlap into one
 * long one.
 */
export const preloadRoute = (pathname) => {
  if (typeof pathname !== 'string' || !pathname) return
  DESTINATIONS.find((destination) => destination.matches(pathname))?.component.preload()
}
